module.exports = __webpack_public_path__ + "img/stat_map_en.6b5828c3.png";